export const CHART = 'CHART';
export const LOCATIONS_MAP = 'LOCATIONS_MAP';
export const REAL_TIME_VALUES = 'REAL_TIME_VALUES';
export const SUMMARY = 'SUMMARY';
export const TABLE = 'TABLE';
export const TASK_STATUSES = 'TASK_STATUSES';
export const IRRIGATION_SUMMARY = 'IRRIGATION_SUMMARY';
